import api from "../axios/axiosInstance";

/**
 * Get all tasks for a contact with optional sorting and filtering
 * @param {Object} params
 * @param {string} params.contact_id - Contact ID (required)
 * @param {string} params.sortBy - Sort order: 'ascending' or 'descending' (optional)
 * @param {string} params.filterBy - Filter: 'completed', 'incomplete', or 'all' (optional)
 * @param {string} params.category - Category ("contact" or "lead"), defaults to "contact"
 */
export const getTasksForContact = async (params) => {
  try {
    const paramsWithCategory = {
      ...params,
      category: params.category || "contact",
    };
    const response = await api.get("/task/getAll", {
      params: paramsWithCategory,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tasks:", error);
    throw error;
  }
};

/**
 * Add or update a task for a contact
 * @param {Object} params
 * @param {string} params.contact_id - Contact ID (required)
 * @param {string} params.task_id - Task ID (optional, for updates)
 * @param {string} params.taskDescription - Task description
 * @param {Date} params.taskDueDate - Task due date
 * @param {string} params.taskDueTime - Task due time
 * @param {boolean} params.taskIsCompleted - Task completion status
 * @param {string} params.category - Category ("contact" or "lead"), defaults to "contact"
 */
export const addOrUpdateTask = async (params) => {
  try {
    const paramsWithCategory = {
      ...params,
      category: params.category || "contact",
    };
    const response = await api.post("/task/addEdit", paramsWithCategory);
    return response.data;
  } catch (error) {
    console.error("Error adding/updating task:", error);
    throw error;
  }
};

/**
 * Delete a task from a contact
 * @param {Object} params
 * @param {string} params.contact_id - Contact ID
 * @param {string} params.task_id - Task ID to delete
 * @param {string} params.category - Category ("contact" or "lead"), defaults to "contact"
 */
export const deleteTask = async (params) => {
  try {
    const paramsWithCategory = {
      ...params,
      category: params.category || "contact",
    };
    const response = await api.delete("/task/delete", {
      data: paramsWithCategory,
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting task:", error);
    throw error;
  }
};
